module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/theme/mags/ortho-field-config-translation.json
// module id = 1229
// module chunks = 0